/**
 * Asynchronously loads the component for PhoneBooking
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
